import React, { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

/** Types out a string once, then holds with a blinking caret. */
export default function Typewriter({
  text,
  className = '',
  speed = 28,
  delay = 0,
  as: Tag = 'span',
  showCaret = true
}) {
  const prefersReducedMotion = useReducedMotion();
  const [output, setOutput] = useState(prefersReducedMotion ? text : '');

  useEffect(() => {
    if (prefersReducedMotion) {
      setOutput(text);
      return undefined;
    }

    setOutput('');
    let index = 0;
    let intervalId;
    const timeoutId = setTimeout(() => {
      intervalId = setInterval(() => {
        index += 1;
        setOutput(text.slice(0, index));
        if (index >= text.length) clearInterval(intervalId);
      }, speed);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [text, speed, delay, prefersReducedMotion]);

  return (
    <Tag className={className}>
      {output}
      {showCaret && (
        <span className="ml-0.5 inline-block animate-caret text-emerald-500" aria-hidden="true">
          ▌
        </span>
      )}
    </Tag>
  );
}
